import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// 1. Ant Design
import { Alert, Button, Form, Input, InputNumber, Modal } from "antd";
// 2. External libraries
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
// 4. Stores
import { getRootStore } from "@/stores/RootStore";
// 5. Types, utils, styles
import styles from "@/styles/Company/Settlements.module.less";
/**
 * Корректировка баланса компании (UC1122, P-7). Знак суммы определяет направление: плюс —
 * скидка/возврат (уменьшает долг), минус — доначисление. Ключ идемпотентности — как у оплаты (§1.7).
 */
const AdjustmentModal = observer(({ open, onClose }) => {
    const { companySettlementsStore: store } = getRootStore();
    const [form] = Form.useForm();
    useEffect(() => {
        if (!open)
            return;
        store.openAdjustmentForm();
        form.resetFields();
    }, [open]);
    const handleCancel = () => {
        store.clearFormError();
        onClose();
    };
    const handleFinish = async (values) => {
        const created = await store.createAdjustment({
            amount: values.amount,
            description: values.description.trim(),
        });
        if (created)
            onClose();
    };
    return (_jsxs(Modal, { open: open, title: "\u041A\u043E\u0440\u0440\u0435\u043A\u0442\u0438\u0440\u043E\u0432\u043A\u0430", onCancel: handleCancel, footer: null, destroyOnHidden: true, children: [store.formError ? (_jsx(Alert, { type: "error", showIcon: true, message: store.formError.text, "data-error-code": store.formError.code ?? undefined, className: styles.notice })) : null, _jsxs(Form, { form: form, layout: "vertical", onFinish: handleFinish, children: [_jsx(Form.Item, { name: "amount", label: "\u0421\u0443\u043C\u043C\u0430 \u0441\u043E \u0437\u043D\u0430\u043A\u043E\u043C \u20BD", extra: "\u041F\u043B\u044E\u0441 \u2014 \u0441\u043A\u0438\u0434\u043A\u0430/\u0432\u043E\u0437\u0432\u0440\u0430\u0442 (\u0443\u043C\u0435\u043D\u044C\u0448\u0430\u0435\u0442 \u0434\u043E\u043B\u0433), \u043C\u0438\u043D\u0443\u0441 \u2014 \u0434\u043E\u043D\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u0435", rules: [
                            { required: true, message: "Введите сумму" },
                            {
                                validator: (_, value) => value === null || value === undefined || value === 0
                                    ? Promise.reject(new Error("Сумма не может быть нулевой"))
                                    : Promise.resolve(),
                            },
                        ], children: _jsx(InputNumber, { precision: 2, className: styles.fullWidth }) }), _jsx(Form.Item, { name: "description", label: "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439", rules: [
                            { required: true, whitespace: true, message: "Укажите комментарий" },
                            { min: 3, message: "Минимум 3 символа" },
                        ], children: _jsx(Input.TextArea, { autoSize: { minRows: 2, maxRows: 4 }, maxLength: 500, showCount: true }) }), _jsx(Form.Item, { children: _jsx(Button, { type: "primary", htmlType: "submit", loading: store.isSubmitting, children: "\u041F\u0440\u043E\u0432\u0435\u0441\u0442\u0438" }) })] })] }));
});
AdjustmentModal.displayName = "AdjustmentModal";
export default AdjustmentModal;
